import { Modal } from "antd"
import { useReactivateMember } from "@mimber/client/mimber-organization"
import { message } from "@mimber/ui-web"

export const useReactivateMemberModal = (
  memberUuid: string,
  onSuccess?: () => void
) => {
  const [modal, contextHolder] = Modal.useModal()
  const reactivateMutation = useReactivateMember(memberUuid)

  const showReactivateMemberModal = (): void => {
    modal.confirm({
      title: "Reactivate Member",
      content:
        "Are you sure you want to reactivate this member? They will regain access to the organization.",
      okText: "Reactivate",
      cancelText: "Cancel",
      onOk: () =>
        new Promise<void>((resolve, reject) => {
          reactivateMutation.mutate(undefined, {
            onSuccess: () => {
              message.success("Member reactivated successfully")
              onSuccess?.()
              resolve()
            },
            onError: (error) => {
              message.error(`Failed to reactivate member: ${error.message}`)
              reject()
            },
          })
        }),
    })
  }

  return {
    contextHolder,
    showReactivateMemberModal,
  }
}
